import React from "react";
import "./AccessExpired.css";

const AccessExpired = () => {
  return (
    <div className="expired-container">
      <div className="expired-card">
        <img
          src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png"
          alt="Expired"
          className="expired-icon"
        />
        <h2 className="expired-title">Access Expired</h2>
        <p className="expired-text">
          Your student portal validity has expired. Please renew your
          subscription to continue accessing the content.
        </p>
      </div>
    </div>
  );
};

export default AccessExpired;
